import { Wallet } from '@/api/auth';
import { Real } from '@/api/games';
import { CurrencyCode } from '@/helpers/currency';

const currenciesPriority: string[] = [
  CurrencyCode.AUD,
  CurrencyCode.CAD,
  CurrencyCode.EUR,
  CurrencyCode.NZD,
  CurrencyCode.NOK,
  CurrencyCode.BTC,
  CurrencyCode.USD,
  CurrencyCode.LTC,
  CurrencyCode.DOG,
  CurrencyCode.ETH,
  CurrencyCode.BRL,
  CurrencyCode.USDT,
  CurrencyCode.BCH,
  CurrencyCode.RUB,
  CurrencyCode.ZAR,
];

const sortByPriority = (a: string, b: string) => {
  const priorityA = currenciesPriority.indexOf(a);
  const priorityB = currenciesPriority.indexOf(b);

  return priorityA - priorityB;
};

export const getAvailableRecommendedCurrency = (
  real: Real,
  wallets: Wallet[]
) => {
  const availableCurrencies = Object.keys(real);

  if (availableCurrencies.length === 0) return;

  const firstAvailableCurrency = availableCurrencies[0];

  if (wallets.length === 0) return firstAvailableCurrency;

  const walletCurrencies = wallets.map(({ currency }) => currency);

  const sortedWalletCurrenciesByPriority =
    walletCurrencies.sort(sortByPriority);

  const currencyByPriority = sortedWalletCurrenciesByPriority.find((currency) =>
    availableCurrencies.includes(currency)
  );

  return currencyByPriority ?? firstAvailableCurrency;
};
